"use client";

import styles from "./Footer.module.css";
import { useRef } from "react";

import Request from "./Request"; // Request 컴포넌트 import
import { useLocation } from 'react-router-dom';

function Footer({ setFooterActive, pageColor }) {
    const footerRef = useRef(null);
    const location = useLocation();
    const pathname = location.pathname;

    const showRequest =
        !pathname.startsWith("/result") && !pathname.startsWith("/diagnosis");

    const gradientStyle = pageColor ? {
        '--footer-gradient': `linear-gradient(0deg, 
            rgba(${pageColor.r}, ${pageColor.g}, ${pageColor.b}, 0.3) 0%, 
            rgba(${pageColor.r}, ${pageColor.g}, ${pageColor.b}, 0.1) 50%,
            rgba(255, 255, 255, 1) 100%)`
    } : {};

    return (
        <footer id="footer" ref={footerRef} className={styles.footer} style={gradientStyle}>
            <div className={styles.footerWrap}>
                {showRequest && <Request setFooterActive={setFooterActive} />}
                <div className={styles.footerInfo}>
                    <div className={styles.footerInfoBox}>
                        <div className={styles.footerInfoTop}>
                           {/*  <div className={styles.linkBox}>
                                <div>
                                    <a
                                        href="https://www.pibok.co.kr/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        PIB 퍼스널이미지연구소
                                    </a>
                                </div>
                                <div>
                                    <a
                                        href="https://www.piba.co.kr/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        PIB 아카데미
                                    </a>
                                </div>
                            </div> */}
                            <div className={styles.snsIconBox}>
                                <ul>
                                    {/*                                     <li>
                                        <a
                                            href="https://www.instagram.com/color_okki?igsh=NnZncmFqa3V4MTRs"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img
                                                src="/image/icon_footer_insta.png"
                                                alt="insta"
                                            />
                                        </a>
                                    </li> */}
                                    <li>
                                        <a
                                            href="https://pf.kakao.com/_UuVkxj"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                        카카오톡 채널
                                            <img
                                                src="/image/icon-kakao-ch.png"
                                                alt="cafe"
                                            />

                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className={styles.footerInfoBottom}>
                            <div className={styles.infoLeft}>
                                <span>한국감성색채협회</span>
                                <span>|</span>
                                <span>
                                    서울시 서초구 서초동 1699-4 헤라피스 빌딩7층
                                    06605
                                </span>
                            </div>
                            <div className={styles.infoRight}>
                                <span>ksca2103@naver.com</span>
                                <span>|</span>
                                <span>고객센터 : 02-537-2258 </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;